var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m62 4v10h-60v-10c0-1.1.9-2 2-2h56c1.1 0 2 .9 2 2z",
    fill: "#5cd6b3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m60 44h-56c-1.105 0-2-.895-2-2v-28h60v28c0 1.105-.895 2-2 2z",
    fill: "#e6e9ed"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m34 18h24v12h-24z",
    fill: "#fcd770"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m6 34h12v6h-12z",
    fill: "#ff826e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m22 6h4v4h-4z",
    fill: "#e6e9ed"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14 6h4v4h-4z",
    fill: "#e6e9ed"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m6 6h4v4h-4z",
    fill: "#e6e9ed"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m48 34h-24c-1.1 0-2 .9-2 2v8 12c0 1.1.9 2 2 2h26v-22c0-1.1-.9-2-2-2z",
    fill: "#ffeaa7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 46,
    fill: "#69d6f4",
    r: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m50 48.33 10 1.67-3 3 5 5-4 4-5-5-3 3-.33-2-1.67-10z",
    fill: "#ff826e"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36 37c-4.962 0-9 4.038-9 9s4.038 9 9 9 9-4.038 9-9-4.038-9-9-9zm-1.589 12c-.17-.61-.297-1.28-.362-2h3.901c-.065.72-.192 1.39-.362 2zm2.408 2c-.28.564-.567 1.032-.818 1.395-.251-.363-.539-.831-.819-1.395zm-2.77-6c.065-.72.192-1.39.362-2h3.177c.17.61.297 1.28.362 2zm1.133-4c.28-.564.567-1.032.818-1.395.251.363.539.831.818 1.395zm-2.203 0h-1.869c.747-.731 1.658-1.293 2.67-1.633-.272.471-.549 1.014-.801 1.633zm-.632 2c-.145.623-.256 1.288-.309 2h-2.958c.102-.706.308-1.378.605-2zm-.309 4c.053.712.164 1.377.309 2h-2.662c-.297-.622-.503-1.294-.605-2zm.941 4c.252.619.529 1.162.801 1.633-1.013-.34-1.923-.902-2.67-1.633zm6.042 0h1.869c-.747.731-1.658 1.293-2.67 1.633.272-.471.549-1.014.801-1.633zm.632-2c.145-.623.256-1.288.309-2h2.958c-.102.706-.308 1.378-.605 2zm.309-4c-.053-.712-.164-1.377-.309-2h2.662c.297.622.503 1.294.605 2zm-.941-4c-.252-.619-.529-1.162-.801-1.633 1.013.34 1.923.902 2.67 1.633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.414 53 3.667-3.667-11.081-1.847v-2.486h9c1.654 0 3-1.346 3-3v-38c0-1.654-1.346-3-3-3h-56c-1.654 0-3 1.346-3 3v38c0 1.654 1.346 3 3 3h17v11c0 1.654 1.346 3 3 3h24.82l.513 3.081 3.667-3.667 5 5 5.414-5.414zm-54.414-50h56c.551 0 1 .449 1 1v9h-58v-9c0-.551.449-1 1-1zm0 40c-.551 0-1-.449-1-1v-27h58v27c0 .551-.449 1-1 1h-9v-7c0-1.654-1.346-3-3-3h-24c-1.654 0-3 1.346-3 3v7zm20 14c-.551 0-1-.449-1-1v-20c0-.551.449-1 1-1h24c.551 0 1 .449 1 1v11.153l-2.216-.369 1.702 10.216zm29-1.414-2.333 2.333-1.451-8.703 8.703 1.451-2.333 2.333 5 5-2.586 2.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 5h-6v6h6zm-2 4h-2v-2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 5h-6v6h6zm-2 4h-2v-2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 5h-6v6h6zm-2 4h-2v-2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 17h-26v14h26zm-2 12h-22v-10h22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 17h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 17h22v2h-22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 21h26v2h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 25h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 25h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 25h18v2h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 29h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 29h22v2h-22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 41h14v-8h-14zm2-6h10v4h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 37h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 37h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 53h2v2h-2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.ca70c6b1e90b2a875497d25a5f5bd857.svg";
export { ForwardRef as ReactComponent };